import React, { Component } from 'react'
import { HeaderView } from '@merchant-backend/common-components'
import { statistic, getCaseManageTitle } from '@util'
import { CASE_INTRODUCE, CASE_MANAGE_PATH } from '@constant'
import { Link } from 'react-router'
import style from './style.module.less'

export default class extends Component {
  componentDidMount() {
    statistic(CASE_INTRODUCE)
  }
  render() {
    const header = [
      <Link to={CASE_MANAGE_PATH}>{getCaseManageTitle()}</Link>,
      '关联客照'
    ]

    return (
      <HeaderView title="关联客照" header={header}>
        <div className={style.wrap}>
          <img src="//qnm.hunliji.com/o_1d22b2ubp1aobeb0112n1evo3te9.png" />
          <img src="//qnm.hunliji.com/o_1d22b3ma22j0mfhr43s2ce7g9.png" />
          <img src="//qnm.hunliji.com/o_1cjv663pse6p1f54fgm1dvp5aa.jpg" />
          <img src="//qnm.hunliji.com/o_1d1v5juagtnugn11514bmao8e.png" />
        </div>
      </HeaderView>
    )
  }
}
